import { render, staticRenderFns } from "./SkillMatrix.vue?vue&type=template&id=97b2a7e8&"
import script from "./SkillMatrix.vue?vue&type=script&lang=js&"
export * from "./SkillMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SkillMatrix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports